module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "id": 'column-' + _vm.column.id
    }
  }, [_vm._v("\n\t" + _vm._s(_vm.column.name) + "\n\t"), (_vm.column.isSortable) ? _c('button', {
    staticClass: "sortable-button",
    on: {
      "click": function($event) {
        _vm.onColumnSortable(_vm.column)
      }
    }
  }, [(_vm.column.isSortable.down) ? _c('i', {
    staticClass: "sortable-icon material-icons icon"
  }, [_vm._v("arrow_drop_down")]) : _vm._e(), _vm._v(" "), (_vm.column.isSortable.up) ? _c('i', {
    staticClass: "sortable-icon material-icons icon"
  }, [_vm._v("arrow_drop_up")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83666942","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TableColumnItem.vue
// module id = 7
// module chunks = 0